import React from "react";

const DetailFieldWrapper = ({ label, children }) => (
  <div className="mb-3">
    <label className="text-muted fs-12 mb-2 d-block">{label}</label>
    {children}
  </div>
);

export default DetailFieldWrapper;
